import { presentUuid } from './formatters';
import { sortPrintersByName } from './printers';

export function upsertInProgressJob(jobs, job) {
    if (!job?.printer_uuid) {
        return jobs || [];
    }

    const jobId = job.id || job.uuid;
    const next = (jobs || []).filter(
        (row) => row.printer_uuid !== job.printer_uuid && (row.id || row.uuid) !== jobId,
    );

    if (job.status === 'em_andamento') {
        next.push({
            ...job,
            id: jobId,
            uuid: job.uuid || jobId,
        });
    }

    return next;
}

export function removeInProgressJob(jobs, jobUuid) {
    if (!jobUuid) {
        return jobs || [];
    }

    return (jobs || []).filter((row) => (row.id || row.uuid) !== jobUuid);
}

/** Um card por impressora com job em andamento. */
export function buildActivePrinterCards(inProgressJobs, printersById = {}) {
    const cardsByPrinter = new Map();

    (inProgressJobs || []).forEach((job) => {
        if (job.status !== 'em_andamento' || !job.printer_uuid) {
            return;
        }

        if (!cardsByPrinter.has(job.printer_uuid)) {
            const printer = printersById[job.printer_uuid] || {};
            cardsByPrinter.set(job.printer_uuid, {
                printer_uuid: job.printer_uuid,
                printer_name: printer.name || presentUuid(job.printer_uuid),
                brand: printer.brand,
                model: printer.model,
                file_name: job.file_name || 'Impressão em andamento',
                job_uuid: job.uuid || job.id,
                filaments: printer.filaments || [],
            });
        }
    });

    return sortPrintersByName(
        [...cardsByPrinter.values()].map((card) => ({
            id: card.printer_uuid,
            name: card.printer_name,
            ...card,
        })),
    );
}
